<template>
  <component
    :is="elementName"
    class="printable-reward-link-redemption-instruction"
  >
    <i
      class="printable-reward-link-redemption-instruction__icon"
      :style="{ color: iconColorToUse }"
    >
      {{ icon }}
    </i>
    <span class="printable-reward-link-redemption-instruction__message">
      {{ message }}
    </span>
  </component>
</template>

<script>
import { TangoCardColors } from '@tangocard/swag'

const DEFAULT_ICON_COLOR = TangoCardColors.orange_800

export default {
  name: 'PrintableRewardLinkRedemptionInstruction',
  props: {
    iconColor: {
      type: String,
      required: false,
      default: DEFAULT_ICON_COLOR
    },
    elementName: {
      type: String,
      required: false,
      default: 'div'
    },
    message: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: '•'
    }
  },
  computed: {
    iconColorToUse () {
      return this.iconColor || DEFAULT_ICON_COLOR
    }
  }
}
</script>

<style lang="scss">
.printable-reward-link-redemption-instruction {
  display: flex;
}

.printable-reward-link-redemption-instruction__icon {
  font-size: 16px;
  margin-right: 10px;
}
</style>
